import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";

import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit"; 
import { editUser } from "../../../apiclients/streamsapi_bridge.js";

const DeleteExternalNumber = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    async function removeThisNumber() {
        console.log(props.props);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        let updates = {};
        updates = {
            reqid: 3,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            agentid: props.useragent,
            external_phnum: {
                delete_phnum: {
                    phNum: props.deleteEXNumber.phNum,
                }


            }
        }
        console.log("updates request for delete extern::::::::::::::: " + JSON.stringify(updates))
        props.setIsloading(true);

        let saverep = await editUser(updates);
        props.setIsloading(false);
        console.log(saverep);
        let saverepeMsg = await saverep.json();
        if (saverepeMsg.status == "Failed") {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    if (err.param_name === "logined_user") {
                        props.setErrorMessage(err.message)
                        props.onClose();
                    }
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();
                        //fieldElement.scrollIntoView({ behavior: "smooth" });
                    }
                });
            }
        } else {
            props.setDeleteExternalFlag(true);
            props.setIsExternalModify(true);
            props.setNewExternalNum({
                phNumber: parseInt(props.deleteEXNumber.phNum),
                id: parseInt(props.deleteEXNumber.id)

            });

            props.setSuccessMessage(`External Number ${props.deleteEXNumber.phNum} removed successfully.`);
            props.onClose();

        }
    }
    return (
        <>
            <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                <span>{t("RemoveUserExtrnalNumbertxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); removeThisNumber() }}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    removeThisNumber();
                }}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}
        </>
    );
});

export default DeleteExternalNumber;
